import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import("../pages/home/page"));
const ProductosPage = lazy(() => import("../pages/productos/page"));
const RitualesGratuitosPage = lazy(() => import("../pages/rituales-gratuitos/page"));
const DespiertaTuVozPage = lazy(() => import("../pages/despierta-tu-voz/page"));
const MiEspacioPage = lazy(() => import("../pages/mi-espacio/page"));
const LoginPage = lazy(() => import("../pages/auth/login/page"));
const RegistroPage = lazy(() => import("../pages/auth/registro/page"));
const ProductoRaizPage = lazy(() => import("../pages/producto-raiz/page"));
const ProductoCuerpoPage = lazy(() => import("../pages/producto-cuerpo/page"));
const ProductoCieloPage = lazy(() => import("../pages/producto-cielo/page"));
const ContenidoRaizPage = lazy(() => import("../pages/contenido/raiz/page"));
const ContenidoCuerpoPage = lazy(() => import("../pages/contenido/cuerpo/page"));
const ContenidoCieloPage = lazy(() => import("../pages/contenido/cielo/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));
import MusaInteriorPage from '../pages/rituales/musa-interior/page';
import PlanetaCorazonPage from '../pages/rituales/planeta-corazon/page';
import FuenteIdeasPage from '../pages/rituales/fuente-ideas/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/productos",
    element: <ProductosPage />,
  },
  {
    path: "/rituales-gratuitos",
    element: <RitualesGratuitosPage />,
  },
  {
    path: "/despierta-tu-voz",
    element: <DespiertaTuVozPage />,
  },
  {
    path: "/mi-espacio",
    element: <MiEspacioPage />,
  },
  {
    path: "/auth/login",
    element: <LoginPage />,
  },
  {
    path: "/auth/registro",
    element: <RegistroPage />,
  },
  {
    path: "/producto/raiz",
    element: <ProductoRaizPage />,
  },
  {
    path: "/producto/cuerpo",
    element: <ProductoCuerpoPage />,
  },
  {
    path: "/producto/cielo",
    element: <ProductoCieloPage />,
  },
  {
    path: "/contenido/raiz",
    element: <ContenidoRaizPage />,
  },
  {
    path: "/contenido/cuerpo",
    element: <ContenidoCuerpoPage />,
  },
  {
    path: "/contenido/cielo",
    element: <ContenidoCieloPage />,
  },
  {
    path: "/rituales/musa-interior",
    element: <MusaInteriorPage />,
  },
  {
    path: "/rituales/planeta-corazon",
    element: <PlanetaCorazonPage />,
  },
  {
    path: "/rituales/fuente-ideas",
    element: <FuenteIdeasPage />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default routes;